export default __webpack_public_path__ + "static/media/deux.63b3aa89.jpg";